// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from file-image-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function FileImageFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M11 0v3.5a.5.5 0 0 0 .41.492L11.5 4H15v11.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5H11ZM9.541 5.122a.41.41 0 0 0-.583 0l-.055.069-1.538 2.373 1.789 2.456c.2.274.224.602.12.88l-.044.1h3.353l.08-.008a.431.431 0 0 0 .305-.585l-.039-.073L9.596 5.19l-.055-.069ZM6.19 6.818a.409.409 0 0 0-.544 0l-.061.068-2.5 3.428-.04.067a.432.432 0 0 0 .297.612l.076.007h5l.076-.007c.27-.05.42-.36.297-.612l-.04-.067-2.5-3.428-.061-.068ZM12.333 0a.5.5 0 0 1 .352.144l2.167 2.143a.5.5 0 0 1 .148.356V3h-2.75a.25.25 0 0 1-.25-.25V0h.333Z"
      />
    </svg>
  );
}
